import React, { useEffect, useState, useCallback } from "react";
import { Table, Space, Select, Input, Spin, Modal, Button, Divider, Card, Tag, Tooltip, Image } from "antd";
import { SearchOutlined, CloseOutlined } from "@ant-design/icons";
import "../members.scss";
import "../index.scss";
import Line from "../../line/index.jsx";
import detailsIcon from "../../../assets/images/details-icon.svg";
import restoreIcon from "../../../assets/images/restoreIcon.png";
import noLogo from "../../../assets/images/noimage.png";
import userServiceApi from "../../../api/userServiceApi.js";
import { getRequest, postRequest } from "../../../api/http.js";
import { toast } from "react-toastify";
import "./deleted-members.scss";
import "../../table/table.scss";
import ViewMicrositeDetailsDeleted from "../../table/viewMicrositeDetailsDeleted.js";
import listViewImage from "../../../assets/images/list-view.svg";
import selectedListViewImage from "../../../assets/images/listview-selected.svg";
import cardViewImage from "../../../assets/images/cardview.svg";
import selectedCardViewImage from "../../../assets/images/cardview-selected.svg";
import Filter from "../filter";
import Interests from "../../json/interestsType.json";
import backBtn from "../../../assets/images/back-arrow.svg";
import { useNavigate } from "react-router-dom";
import { inputFieldCharLimit } from "../../../config/index.js";
import { debounce } from 'lodash';

const DeleteMembers = ({ organizationDeletionTime, setActiveKey }) => {
  const navigate = useNavigate();
  const localAK = sessionStorage.getItem("activeKey");

  const [tableData, setTableData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [loading, setLoading] = useState(false);

  const [tableLoader, setTableLoader] = useState(true);
  const [isModalRestoreOpen, setIsModalRestoreOpen] = useState(false);
  const [restoreRowId, setRestoreRowId] = useState();
  const [orgId, setOrgId] = useState(null);
  const [showTags, setShowTags] = useState(true);

  const [listView, setListView] = useState(true);
  const [cardView, setCardView] = useState(false);

  const [micrositeModalDetails, setMicrositeModalDetails] = useState(false);

  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [sortDirection, setSortDirection] = useState();
  const [sortBy, setSortBy] = useState();
  const [totalOrgs, setTotalOrgs] = useState();
  const [filterExists, setFilterExists] = useState(false);
  const [searchTerm, setSearchTerm] = useState('')

  const [updateFilterData, setUpdateFilterData] = useState(false);

  const [sectorName, setSectorName] = useState("");
  const [subSectorName, setSubSectorName] = useState("");

  const [af, setAf] = useState("");
  const [gl, setGl] = useState("");
  const [ms, setMs] = useState("");
  const [tz, setTz] = useState("");
  const [boolAF, setBoolAf] = useState(false);
  const [boolGL, setBoolGl] = useState(false);
  const [boolMS, setBoolMs] = useState(false);
  const [boolTZ, setBoolTz] = useState(false);

  const [selectedEvent, setSelectedEvent] = useState(
    sessionStorage.getItem("Interest/AssetType")
      ? sessionStorage.getItem("Interest/AssetType")
      : null
  );
  const [size, setSize] = useState(
    sessionStorage.getItem("size") ? sessionStorage.getItem("size") : null
  );
  const [interestName, setInterestName] = useState(
    sessionStorage.getItem("Interest/AssetType")
      ? sessionStorage.getItem("Interest/AssetType")
      : null
  );
  const [sectorId, setSectorId] = useState(
    sessionStorage.getItem("sector") ? sessionStorage.getItem("sector") : null
  );
  const [subSectorId, setSubSectorId] = useState(
    sessionStorage.getItem("subsector")
      ? sessionStorage.getItem("subsector")
      : null
  );
  const partnerID = sessionStorage.getItem("partnerId");

  // Ultra-strict sanitization
  const sanitizeSearchInput = (input) => {
    if (input === undefined || input === null) return '';
    if (typeof input !== 'string') return '';

    // Only allow: letters, numbers, spaces, hyphens, underscores
    const sanitized = input.replace(/[^a-zA-Z0-9\s\-_]/g, '');

    console.log('🔍 Search Sanitization - Input:', `"${input}"`, 'Output:', `"${sanitized}"`);
    return sanitized;
  };

  // Safe URL parameter encoding
  const getSafeSearchParam = (input) => {
    if (!input || input.trim() === '') return '';

    const sanitized = sanitizeSearchInput(input.trim());
    if (!sanitized) return '';

    return encodeURIComponent(sanitized);
  };

  useEffect(() => {
    clearAll();
  }, []);

  const onSearch = (e) => {
    const rawValue = e.target.value || '';
    const sanitizedValue = sanitizeSearchInput(rawValue);
    setSearchTerm(sanitizedValue);
  };

  // Clear search
  const handleClearSearch = () => {
    setSearchTerm('');
    filterMicrosites();
  };

  // Handle enter key press
  const handlePressEnter = (e) => {
    const rawValue = e.target.value || '';
    const sanitizedValue = sanitizeSearchInput(rawValue);

    if (sanitizedValue.trim().length > 0) {
      filterMicrosites();
    }
  };

  const RemoveHandler = (value) => {
    sessionStorage.removeItem(value);
    if (value === "interest") {
      sessionStorage.removeItem("Interest/AssetType");
      setInterestName(null);
      setSelectedEvent(null);
    }
    if (value === "sector") {
      setSectorId(null);
      setSubSectorId(null);
      sessionStorage.removeItem("subsector");
    }
    if (value === "subsector") {
      setSubSectorId(null);
    }
    if (value === "size") {
      setSize(null);
    }
    setUpdateFilterData(!updateFilterData);
    filterMicrosites();
  };

  const filterMicrosites = async (searchValue = null) => {
    setTableLoader(false);
    setLoader(false);
    try {
      const currentSearchTerm = searchValue ?? searchTerm;
      let safeSearchTerm = '';

      if (currentSearchTerm && currentSearchTerm.trim() !== '') {
        safeSearchTerm = getSafeSearchParam(currentSearchTerm);
      }

      let response = await getRequest(
        userServiceApi.getAllDeletedOrganizations(
          pageSize,
          pageNumber,
          interestName,
          sectorId,
          subSectorId,
          size,
          safeSearchTerm, // Use safe search term
          sortDirection,
          sortBy,
          af,
          gl,
          ms,
          tz
        )
      );
      if (response) {
        setTableData(response.data.result);
        setTotalOrgs(response?.data?.totalCount);
        setFilterExists(true);
      }
    } catch (error) {
      console.error("Error fetching deleted organizations:", error);
      toast.error(error?.error || "Failed to load deleted members");
      setTableData([]);
    } finally {
      setLoader(false);
      setTableLoader(false);
    }
  };

  // Debounced search
  const debouncedSearch = useCallback(
    debounce((value) => {
      filterMicrosites(value);
    }, 600),
    [pageSize, pageNumber, interestName, sectorId, subSectorId, size, sortDirection, sortBy, af, gl, ms, tz]
  );

  useEffect(() => {
    if (searchTerm.trim().length > 0) {
      debouncedSearch(searchTerm);
    } else {
      filterMicrosites();
    }
  }, [searchTerm, interestName, sectorId, subSectorId, size, pageNumber, sortDirection, af, gl, ms, tz, localAK]);

  useEffect(() => {
    filterMicrosites();
  }, []);

  const handleOk = () => {
    setIsModalRestoreOpen(true);
  };

  const handleCancelRestore = () => {
    setIsModalRestoreOpen(false);
  };

  const restoreApprovedOrg = async (orgId) => {
    try {
      const response = await postRequest(
        userServiceApi.restoreApprovedOrg(orgId)
      );
      if (response) {
        filterMicrosites();
      }
    } catch (error) {
      console.error("Error restoring organization:", error);
      toast.error(error?.error || "Failed to restore organization");
    }
  };

  const calculateDaysLeft = (dateString) => {
    if (!dateString) {
      return 30;
    }

    const deletionDate = new Date(dateString);
    const thirtyDaysAheadDate = new Date(deletionDate);
    thirtyDaysAheadDate.setDate(thirtyDaysAheadDate.getDate() + organizationDeletionTime);
    const currentDate = new Date();

    const timeDifference = thirtyDaysAheadDate - currentDate;
    const daysLeft = Math.max(0, Math.ceil(timeDifference / (1000 * 60 * 60 * 24)));
    return daysLeft;
  };

  const restoreOrg = () => {
    restoreApprovedOrg(restoreRowId);
    setIsModalRestoreOpen(false);
    toast.success("Organisation restored");
  };

  const setFilterHandler = async (sectorId, subSectorIds, size) => {
    clearAll();
    if (sectorId && subSectorIds) {
      try {
        const partnerId = sessionStorage.getItem("partnerId");
        const sectorResponse = await getRequest(userServiceApi.getAllSectors(partnerId));
        let selectedSector = sectorResponse.data.find(
          (sector) => sector.id === sectorId
        );
        setSectorName(selectedSector?.name ? selectedSector?.name : "");
        const subSectorResponse = await getRequest(
          userServiceApi.getSubSectors(sectorId)
        );
        let selectedSubSector = subSectorResponse.data.find(
          (sector) => sector.id === subSectorIds
        );
        setSubSectorName(selectedSubSector?.name ? selectedSubSector?.name : "");
        setSectorId(sectorId);
        setSubSectorId(subSectorIds);
        setSize(size);
      } catch (error) {
        console.error("Error setting filters:", error);
      }
    } else {
      setSize(size);
    }
  };

  const clearAll = () => {
    sessionStorage.removeItem("Interest/AssetType");
    setInterestName(null);
    setSelectedEvent(null);
    setSubSectorName("");
    setSectorId(null);
    setSubSectorId(null);
    setSize(null);
  };

  const interestChange = (e) => {
    sessionStorage.setItem("Interest/AssetType", e);
    setInterestName(e);
    setSelectedEvent(e);
  };

  const handleAF = () => {
    if (!boolAF) {
      setAf("A-F");
      setBoolAf(true);
    } else {
      setAf("");
      setBoolAf(false);
    }
  };

  const handleGL = () => {
    if (!boolGL) {
      setGl("G-L");
      setBoolGl(true);
    } else {
      setGl("");
      setBoolGl(false);
    }
  };

  const handleMS = () => {
    if (!boolMS) {
      setMs("M-S");
      setBoolMs(true);
    } else {
      setMs("");
      setBoolMs(false);
    }
  };

  const handleTZ = () => {
    if (!boolTZ) {
      setTz("T-Z");
      setBoolTz(true);
    } else {
      setTz("");
      setBoolTz(false);
    }
  };

  const columns = [
    {
      title: "Organisation details",
      dataIndex: "mediaLink",
      key: "mediaLink",
      className: "logo-deleted",
      render: (t, r) =>
        <div className="image-container">
          {r.mediaLink ? (
            <>
              <div className="imageWith">
                <div className="imageWithLogo">
                  <Image src={`${r.mediaLink}`} preview={false} alt="Logo" />
                </div>
                <div className="imageWithTitle">{r.name}</div>

              </div>
            </>

          ) : (
            <>
              <div className="imageWith">
                <div className="imageWithLogo">
                  <Image src={`${noLogo}`} preview={false} alt="Logo" />
                </div>
                <div className="imageWithTitle">{r.name}</div>

              </div>
            </>
          )}
        </div>,
    },
    // {
    //   title: " ",
    //   dataIndex: "name",
    //   key: "name",
    //   render: (t, r) => (<Space>
    //     <span style={{
    //       fontSize: "17px",
    //       overflow: "hidden",
    //       textOverflow: "ellipsis",
    //       maxWidth: "200px",
    //       whiteSpace: "nowrap",
    //       display: "inline-block"
    //     }}>
    //       {r.name}
    //     </span>
    //   </Space>)
    // },
    {
      title: <Space>Time left for permanent deletion</Space>,
      dataIndex: "",
      key: "",
      className: "time",
      render: (row) => (
        <div className="text-style">
          <div className={`text-item ${calculateDaysLeft(row.deletedAt) < 30 ? `highlight` : `not-highlighted`}`}>
            {" "}
            {` ${calculateDaysLeft(
              row.deletedAt
            )} days`
            }
          </div>
        </div>
      )
    },
    {
      title: <Space>Organisation Size</Space>,
      dataIndex: "size",
      key: "size",
      render: (record, oneOrgData) => (
        <div>
          {oneOrgData?.size
            ? oneOrgData.size.charAt(0).toUpperCase() +
            oneOrgData.size.slice(1).toLowerCase()
            : ""}
        </div>
      )
    },
    {
      title: <Space>Status</Space>,
      dataIndex: "",
      key: "approvalStatus",
      render: (record, value) => (
        <div>
          {record.approvalStatus === 'APPROVED' ? (
            <p>
              {record.approvalStatus
                ? record.approvalStatus.charAt(0).toUpperCase() +
                record.approvalStatus.slice(1).toLowerCase()
                : ""}
            </p>
          ) : record.approvalStatus === "DENIED" ? (
            <p>
              {record.approvalStatus
                ? record.approvalStatus.charAt(0).toUpperCase() +
                record.approvalStatus.slice(1).toLowerCase()
                : ""}
            </p>
          ) : (
            <p>
              {" "}
              Waiting for approval
            </p>
          )}
        </div>
      ),
    },
    {
      title: " ",
      dataIndex: "",
      key: "action",
      render: (value, row, index) => (
        <div>
          <Space size="middle">
            <div
              className="icon-style"
              onClick={() => showDetailsHandler(row.id)}
            >
              <img src={detailsIcon} alt="Details" title="Preview" />
            </div>
            <div
              className="icon-style"
              onClick={() => showRestoreHandler(row.id)}
            >
              <img src={restoreIcon} alt="Restore" title="Restore" />
            </div>
          </Space>
        </div>
      ),
    },
  ];

  const showDetailsHandler = (organizationId) => {
    setOrgId(organizationId);
    setMicrositeModalDetails(true);
  };

  const showRestoreHandler = (id) => {
    setIsModalRestoreOpen(true);
    setRestoreRowId(id);
  };

  const closeModalDetails = () => {
    setMicrositeModalDetails(false);
  };

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  return (
    <div className="table-container">
      <div className="d-flex justify-content-between py-3 px-2 pb-0">
        <div className="d-flex align-items-center">
          <div>
            <img src={backBtn}
              onClick={() => {
                setActiveKey("1");
                clearAll();
              }}
              alt="Back"
              style={{ cursor: 'pointer' }}
            />
          </div>
          <span style={{ fontSize: '20px', fontWeight: 600 }} className="px-3" >Restore Members</span>
        </div>
        <div className="d-flex" >
          <div className="list-view" onClick={() => {
            setCardView(false);
            setListView(true);
          }}>
            {listView ? (
              <img src={selectedListViewImage} alt="List view selected" />
            ) : (
              <img src={listViewImage} alt="List view" />
            )}
          </div>
          <Divider type="vertical" className="divider h-100 " />
          <div className="card-view" onClick={() => {
            setListView(false);
            setCardView(true);
          }}>
            {cardView ? (
              <img src={selectedCardViewImage} alt="Card view selected" />
            ) : (
              <img src={cardViewImage} alt="Card view" />
            )}
          </div>
        </div>
      </div>
      <div className="main-container pb-2 ">
        <div className="filters-container">
          <div className="search-bar-container">
            <Tooltip placement="top" title='Allowed: letters, numbers, spaces, hyphens (-), and underscores (_).'>
              <Input
                size="large"
                className="input"
                placeholder="Search Organisation"
                suffix={
                  searchTerm ? (
                    <CloseOutlined
                      style={{ color: "#CC0E2D", verticalAlign: "middle", cursor: 'pointer' }}
                      onClick={handleClearSearch}
                    />
                  ) : (
                    <SearchOutlined />
                  )
                }
                onChange={onSearch}
                onPressEnter={handlePressEnter}
                value={searchTerm}
                maxLength={inputFieldCharLimit}
              />
            </Tooltip>
          </div>
          <div className="filter-btn">
            <Filter
              mask={false}
              interest={selectedEvent}
              setData={setFilterHandler}
              updateFilterData={updateFilterData}
              span={9}
            />
          </div>
          <div className="interests-container">
            <Select
              className="select-drpdwn"
              value={interestName}
              placeholder="Select Interest"
              onChange={(e) => interestChange(e)}
            >
              {Interests.map((Interest, i) => (
                <Select.Option key={i} value={Interest.id}>
                  {Interest.name}
                </Select.Option>
              ))}
            </Select>
          </div>
          <div className="alphabet-filters">
            <Button
              id="A-F-btn"
              className={`alpha-filter-btn ${boolAF ? `selected` : ``}`}
              onClick={handleAF}
            >
              A-F
            </Button>
            <Button
              id="G-L-btn"
              className={`alpha-filter-btn ${boolGL ? `selected` : ``}`}
              onClick={handleGL}
            >
              G-L
            </Button>
            <Button
              id="M-S-btn"
              className={`alpha-filter-btn ${boolMS ? `selected` : ``}`}
              onClick={handleMS}
            >
              M-S
            </Button>
            <Button
              id="T-Z-btn"
              className={`alpha-filter-btn ${boolTZ ? `selected` : ``}`}
              onClick={handleTZ}
            >
              T-Z
            </Button>
          </div>
        </div>

        <div>
          {showTags ? (
            <div className="org-filter-options">
              <div className="filter-options">
                {interestName ? (
                  <Tag
                    closable
                    onClose={RemoveHandler.bind(this, "interest")}
                  >
                    {interestName === "APPRENTICESHIP"
                      ? "Apprenticeship"
                      : interestName === "VACANCY"
                        ? "Vacancies"
                        : interestName === "PRODUCT"
                          ? "Products"
                          : interestName === "SERVICE"
                            ? "Service"
                            : interestName === "WORK_EXPERIENCE"
                              ? "Experience of work"
                              : ""}
                  </Tag>
                ) : null}
                {sectorId ? (
                  <Tag
                    closable
                    onClose={RemoveHandler.bind(this, "sector")}
                  >
                    {sectorName}
                  </Tag>
                ) : null}
                {subSectorId ? (
                  <Tag
                    closable
                    onClose={RemoveHandler.bind(this, "subsector")}
                  >
                    {subSectorName}
                  </Tag>
                ) : null}
                {size ? (
                  <Tag closable onClose={RemoveHandler.bind(this, "size")}>
                    {size === "MICRO"
                      ? "Micro"
                      : size === "SMALL"
                        ? "Small"
                        : size === "MEDIUM"
                          ? "Medium"
                          : size === "LARGE"
                            ? "Large"
                            : ""}
                  </Tag>
                ) : null}
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>

      {loader ? (
        <div className="data-loader">
          <Spin className="spin" tip="Loading" size="large" />
        </div>
      ) : (
        <div>
          {!tableLoader && tableData && (listView ? (
            <Table
              rowClassName={() => "rowClassName1"}
              columns={columns}
              dataSource={tableData}
              pagination={false}
              rowKey="id"
              locale={{
                emptyText: (
                  <div className="no-data-message">
                    <h3 style={{ textAlign: "center", margin: "50px 0" }}>
                      {searchTerm ? `No results found for "${searchTerm}"` : "No deleted members available"}
                    </h3>
                  </div>
                ),
              }}
            />
          ) : (
            <div className="main-container">
              <div>
                {tableData.length > 0 ? tableData.map((org) => (
                  <div className="member-cards-container">
                    <Card className="partner-card" key={org.id} size="small">
                      <div className="card-header-container">
                        <div className="card-heading">{org.name}</div>
                        <div className="icons-stack">
                          <div
                            className="icon-style"
                            onClick={() => showDetailsHandler(org.id)}
                          >
                            <img src={detailsIcon} alt="Details" title="Preview" />
                          </div>
                          <Line />
                          <div
                            className="icon-style"
                            onClick={() => showRestoreHandler(org.id)}
                          >
                            <img src={restoreIcon} alt="Restore" title="Restore" />
                          </div>
                        </div>
                      </div>
                      <div className="card-main-container">
                        <div className="org-logo-container">
                          {org.mediaLink ? (
                            <img src={org.mediaLink} alt={org.name} />
                          ) : (
                            <img src={noLogo} alt="No logo" />
                          )}
                        </div>
                        <div className="org-details-container">
                          <div className="configure-btn size">
                            {org.size === "MICRO" ? "Micro"
                              : org.size === "SMALL" ? "Small"
                                : org.size === "LARGE" ? "Large"
                                  : ""
                            }
                          </div>
                          <Line />
                          <div className="configure-btn status">
                            {org.mediaLink !== "" ? (
                              <p>Approved</p>
                            ) : org.approvalStatus === "DENIED" ? (
                              <p>Denied</p>
                            ) : (
                              <p>Waiting for approval</p>
                            )}
                          </div>
                          <Line />
                          <div className="configure-btn days">
                            <p className={`days-left ${calculateDaysLeft(org.deletedAt) <= 30 ? "days-red" : ""}`}>
                              {calculateDaysLeft(org.deletedAt)}
                            </p>
                            <div className="waiting-label-container">
                              <p>days for</p>
                              <p>permanent deletion</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Card>
                  </div>
                )) : (
                  <div className="pt-5 d-flex flex-column justify-content-center align-items-center col">
                    <svg className="mt-5" width="64" height="41" viewBox="0 0 64 41" xmlns="http://www.w3.org/2000/svg">
                      <g transform="translate(0 1)" fill="none" fillRule="evenodd">
                        <ellipse fill="#f5f5f5" cx="32" cy="33" rx="32" ry="7"></ellipse>
                        <g fillRule="nonzero" stroke="#d9d9d9">
                          <path d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"></path>
                          <path d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z" fill="#fafafa"></path>
                        </g>
                      </g>
                    </svg>
                    <p className="card-subtitle text-center text-black-50 pt-2 p-0 m-0">
                      {searchTerm ? `No results found for "${searchTerm}"` : "No deleted members available"}
                    </p>
                  </div>
                )}
              </div>
            </div>
          ))}

          <Modal
            className="confirmation-modal"
            open={isModalRestoreOpen}
            footer={null}
            onOk={handleOk}
            onCancel={handleCancelRestore}
            destroyOnClose={true}
            closable={false}
          >
            <div className="message">
              <p>Are you sure you want to restore this organization?</p>
            </div>
            <div className="modalBtns">
              <Button
                label="No"
                className="cancel-btn"
                onClick={handleCancelRestore}
              >
                Cancel
              </Button>
              <Button label="Yes" className="confirm-btn" onClick={restoreOrg}>
                Yes
              </Button>
            </div>
          </Modal>

          {micrositeModalDetails && (
            <ViewMicrositeDetailsDeleted
              orgId={orgId}
              closeModal={closeModalDetails}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default DeleteMembers;